import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { GestaoBeneficarioService } from '../gestao-beneficiario.service';
import { NotificationsService } from 'angular2-notifications';
import { DocumentoHelper } from '../../../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-modal-novo-beneficiario',
  templateUrl: './modal-novo-beneficiario.component.html',
  styleUrls: ['./modal-novo-beneficiario.component.scss']
})
export class ModalNovoBeneficiarioComponent implements OnInit {


  @Output() confirmaNovoEmitter: EventEmitter<void> = new EventEmitter<void>();


  public customLogin = null;
  public formNovo: FormGroup = null;
  public cnpjCpf = null;

  constructor(
    protected ref: NbDialogRef<ModalNovoBeneficiarioComponent>,
    private formBuilder: FormBuilder,
    private service: GestaoBeneficarioService,
    private notificationService: NotificationsService,
  ) {
    this.formNovo = this.formBuilder.group({
      cnpj: [''],
      razaoSocial: [''],
      nomeFantasia: ['']
  });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;

  }

  confirmar() {
    const v = this.formNovo.value;
    const payload = {
      cnpj: this.normalizarCnpjCpfParaBackend(v.cnpj),
      razaoSocial: v.razaoSocial,
      nomeFantasia: v.nomeFantasia,
    };
    this.service.postBeneficiario(payload,
      _response=>{
        this.confirmaNovoEmitter.emit();
        this.notificationService.success("Beneficiário cadastrado com sucesso!")
      },
      _error=>{
        this.notificationService.error(_error.message);
      })
  }


  cancelar() {
    this.ref.close();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }
}
